const css = require('./users-list.css');
const { cut } = require('../../../../helpers/utils');
const Filter = require('./users-filter');

const $ = require('jquery');

const LIST_WRAPPER_SELECTOR = cut(css.listWrapper);
const LIST_SELECTOR = cut(css.list);
const SCROLLBAR_SELECTOR = cut(css.scrollbar);
const SCROLLTRACK_SELECTOR = cut(css.scrolltrack);
const LIST_CONTENT = cut(css.listContent);
let { redirect } = require('../../../../signals/utils');

class UsersList {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.initBaron();

        let $el = $(this.$context.element);

        this.$wrapper = $el.find(LIST_SELECTOR);
        this.$scrollContent = this.$wrapper.find(LIST_CONTENT);

        return {
            mouseenter: {
                [LIST_WRAPPER_SELECTOR]: this.blockWindowScroll
            },
            mouseleave: {
                [LIST_WRAPPER_SELECTOR]: this.unblockWindowScroll
            },
            click: {
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }

    unbind () {
        if (this.$wrapper) {
            this.$wrapper.off('scroll', this._scrollHanlder);
        }
    }

    /**
     * Инициализация baron
     */
    initBaron () {
        let baron = require('baron');
        let elementId = this.$context.attributes.id;

        baron({
            root: `#${elementId} ${LIST_WRAPPER_SELECTOR}`,
            scroller: LIST_SELECTOR,
            bar: SCROLLBAR_SELECTOR,
            track: SCROLLTRACK_SELECTOR,
            $
        });
    }

    blockWindowScroll () {
        let x = window.scrollX || window.pageXOffset || document.body.scrollLeft;
        let y = window.scrollY || window.pageYOffset || document.body.scrollTop;

        window.onscroll = () => {
            window.scrollTo(x, y);
        };
    }

    unblockWindowScroll () {
        window.onscroll = null;
    }
}

module.exports = {
    constructor: UsersList,
    children: [
        {
            name: 'users-filter',
            component: Filter
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/users/users-list/index.js